export enum Environments {
  LOCAL = 'local',
  TEST = 'test',
  DEVELOPMENT = 'development',
  UAT = 'uat',
  PRODUCTION = 'production'
}
